import React from 'react';
import styles from 'src/styles/layout.module.css';
import MainLayout from 'src/components/layouts/MainLayout';
import { Breadcrumb, Button, Space, Typography } from 'antd';
import { InteractionTwoTone } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import tileStyles from 'src/styles/tile.module.css';

import { useFirmwareGroupsValues } from 'src/features/firmwareGroups/firmwareGroups.hooks';

const FirmwaresGroupsPage: React.FC = () => {
  const firmwareGroups = useFirmwareGroupsValues();

  return (
    <MainLayout>
      <div className={styles.mainGrid}>
        <div className={styles.breadCrumbs}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to='/settings/groups'>
                <Space>
                  <InteractionTwoTone />
                  Группы устройств
                </Space>
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className={styles.contentArea}>
          <Typography.Title level={2} className={styles.title}>
            Группы устройств
          </Typography.Title>
          <div>
            {firmwareGroups.map(c => (
              <div key={c.name} className={tileStyles.listTile}>
                <Link to={`/settings/groups/${c.name}`} className={tileStyles.tileName}>
                  <Space>
                    <InteractionTwoTone />
                    {c.name}
                  </Space>
                </Link>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.sidebar}>
          <Space>
            <Button type='primary' onClick={() => ({})}>
              Создать новую группу устройств
            </Button>
          </Space>
        </div>
      </div>
    </MainLayout>
  );
};

export default FirmwaresGroupsPage;
